module.exports = __webpack_public_path__ + "img/puree-concentrates.9cd90415.jpg";